import type { ReactNode } from 'react';

import { Box } from '@mui/material';

import { DATAHUB_SPACING_LG } from '@/features/DataHub/constants/ui';

export const ExportDrawerFooter = ({ children }: { children: ReactNode }) => {
  return (
    <Box
      sx={{
        minHeight: '96px',
        width: '100%',
        backgroundColor: 'background.main',
        borderTop: '1px solid',
        borderColor: 'info.dark',
        p: DATAHUB_SPACING_LG,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: DATAHUB_SPACING_LG,
        '& > *': {
          flex: 1
        }
      }}
    >
      {children}
    </Box>
  );
};
